import React, { Component } from 'react'
import AreaResultadoError from './area_resultado_error';
import AreaResultadoAutorizado from './area_resultado_autorizado';
import AreaResultadoNaoAutorizado from './areal_resultado_nao_autorizado';
import '@styles/consulta-pronto-socorro.css'

class AreaResultadoAutorizacao extends Component {

    callResetStates = () => {
        this.props.setInitialFieldsState();
        this.props.resetAllStates();
    }

    render() {
        const { beneficiario, apiError, msgErrorApi } = this.props;

        if (beneficiario === 'API_ERROR' || apiError)
            return <AreaResultadoError setInitialFieldsState={this.callResetStates} msgErrorApi={msgErrorApi} />
        else if (beneficiario && beneficiario.data && beneficiario.data.SolicitacaoProcedimento.Senha != null) {
            return <AreaResultadoAutorizado beneficiario={beneficiario} setInitialFieldsState={this.callResetStates} />
        }
        else if (beneficiario && beneficiario.data) {
            return <AreaResultadoNaoAutorizado beneficiario={beneficiario} setInitialFieldsState={this.callResetStates} />
        }
        else
            return <div></div>
    }
}

export default AreaResultadoAutorizacao